import { render, staticRenderFns } from "./EfsMarginLedgerForm.vue?vue&type=template&id=051537b8&"
import script from "./EfsMarginLedgerForm.vue?vue&type=script&lang=js&"
export * from "./EfsMarginLedgerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports